import { Inject, Injectable, EventEmitter } from '@angular/core';
import { BreadcrumbLink } from '../models/Breadcrumb';
import { map, catchError, tap } from 'rxjs/operators'
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { TCCPConstantValues } from '../models/tccp-constants';
import { TCCPLoggerService } from '../services/tccp-logger.service';
import { environment } from '../../../environments/environment';
import { firstValueFrom, lastValueFrom, Observable } from 'rxjs';
import { TCCPHttpService } from '../services/tccp-http.service';
import { TCCPLocalStorageService } from '../../shared/services/tccp-local-storage.service';
import * as _ from 'lodash';
import { Permission } from '../models/user-role';
import { VehicleFeature } from '../models/vehicle-feature';
import { LoaderService } from '../loader/loader.service';
import { HeadUnitPayload } from '../models/headunit-payload';
import { BreadcrumbService } from '../components/breadcrumb/breadcrumb.service';
import { Gtag } from 'angular-gtag';
import { Utilities } from '../../shared/utilities'

@Injectable({
  providedIn: 'root'
})

export class TCCPCommonService {
  public showFeedback = new EventEmitter();
  public changeLayoutStyle = new EventEmitter();
  public clearHomePage = new EventEmitter();
  public clearDashboard = new EventEmitter();
  public clearFlowPage = new EventEmitter();
  public clearDashboardPage = new EventEmitter();
  public selectedModel: BreadcrumbLink = <BreadcrumbLink>({ name: '', link: '' });
  public selectedYear: BreadcrumbLink = <BreadcrumbLink>({ name: '', link: '' });
  public selectedFeature: BreadcrumbLink; BreadcrumbLink = <BreadcrumbLink>({ name: '', link: '' });
  public selectedFeatureId = '';
  public landingPage = true;
  public appName = environment.applicationName;
  public backToDashboardFlow = new EventEmitter();
  public enableFeedback = false;
  public getDoneFlow = new EventEmitter();
  public reviewCommmentLength = new EventEmitter();
  public hideBreadrumb = new EventEmitter();
  public hideHeaderMenus = new EventEmitter();
  public removeZoom = new EventEmitter();
  public isMessageComponentOpened = false;
  public isResourceComponentOpened = false;
  public isVideosComponentOpened = false;
  public vinAutoSuggesstion: string[] = [];
  public vinSummaryDetails = null;
  public hideBanner = new EventEmitter();
  public stepDetailArray = {};
  public vinDetails = null;
  public searchText: string = null;
  public hideModelYearSection = new EventEmitter();
  public searchResultEmitter = new EventEmitter();
  public fromFirstSetupGuide = new EventEmitter();
  public showMessageGuide = new EventEmitter();
  public startLoaderEmitter = new EventEmitter();
  public badgeUrl = `${environment.baseURL}content/`;
  public badgeFileExtension = 'png';
  public badgeList: any[] = [];

  constructor(
    private http: HttpClient, private logger: TCCPLoggerService,
    private httpService: TCCPHttpService, private storageService: TCCPLocalStorageService,
    private loader: LoaderService, private gtag: Gtag, private breadcrumbService: BreadcrumbService) {
  }

  public appBase = TCCPConstantValues[environment.applicationName];
  public envPath = environment.applicationName === 'toyotaguide' ? 'toyota' :
    environment.applicationName === 'lexusguide' ? 'lexus' : environment.applicationName;
  public commonFiles = {
    edit: environment.baseURL + 'content/common/edit.svg',
    delete: environment.baseURL + 'content/common/delete.svg',
    'admin-toyota-logo': environment.baseURL + 'content/common/toyota-logo.png',
    'admin-lexus-logo': environment.baseURL + 'content/common/lexus-logo.png',
    avatar: environment.baseURL + 'content/common/avatar.png',
    'back-arrow': environment.baseURL + 'content/' + environment.applicationName + '/common/back-arrow.svg',
    'next-arrow': environment.baseURL + 'content/' + environment.applicationName + '/common/next-arrow.svg',
    'external-logo': environment.baseURL + 'content/' + this.envPath + '/common/external-logo.png',
    'internal-logo': environment.baseURL + 'content/' + this.envPath + '/common/internal-logo.png',
    compress: environment.baseURL + 'content/common/compress.png',
    'admin-logo': environment.baseURL + 'content/common/admin-portal-logo.png',
    'maintenance-image': environment.baseURL + 'content/common/CTSMaintenance.jpg',
    'playstore-image': environment.baseURL + 'content/common/badges-google.png',
    'appstore-image': environment.baseURL + 'content/common/badges-apple.png',
    'under-maintenance-image': environment.baseURL + 'content/' + environment.applicationName + '/images/under-maintenance.jpg',
    'coming-soon-image': environment.baseURL + 'content/' + environment.applicationName + '/images/coming-soon.jpg'
  };


  getmodelName(): Observable<any> {
    this.appBase = TCCPConstantValues[environment.applicationName];
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting year', '');
    return this.httpService.get(environment.baseURL + Utilities.getEnvironment() + 'vehicle-model?source=' + environment.applicationName).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting vehicle model successful', JSON.stringify(data));
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting vehicle model failed', '', error);
        return error;
      })
    );
  }

  getAllResources(featureType: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting year', '');
    return this.httpService.get(this.appBase.Urls.GET_DOCUMENT_URL + '?source=' + environment.applicationName +
      '&contentType=resource&featureType=' + featureType + '&t=' + new Date().getTime()).pipe(
        map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting vehicle model successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting vehicle model failed', '', error);
          return error;
        })
      );
  }

  getAllVideos(featureType: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting Videos', '');
    return this.httpService.get(this.appBase.Urls.GET_DOCUMENT_URL + '?source=' + environment.applicationName +
      '&contentType=video&featureType=' + featureType + '&t=' + new Date().getTime()).pipe(
        map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting Videos successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting Videos failed', '', error);
          return error;
        })
      );
  }

  getAccessPolicy(): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting Videos', '');
    return this.httpService.get(this.appBase.Urls.GET_ACCESS_POLICY_URL).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting access policy successful', JSON.stringify(data));
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting access policy failed', '', error);
        return error;
      })
    );
  }

  async getAccessPolicyAsync(): Promise<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting Videos', '');
    return this.httpService.get(this.appBase.Urls.GET_ACCESS_POLICY_URL).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting access policy successful', JSON.stringify(data));
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting access policy failed', '', error);
        return error;
      })
    );
  }

  async getUserAccessRole(upn): Promise<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting Access Role', '');
    return this.httpService.get(this.appBase.Urls.GET_ACCESS_ROLE_URL + '/' + upn).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting access Role successful', JSON.stringify(data));
        if (!this.storageService.getRoles()) {
          this.storageService.setRoles(_.map(data, 'roles'));
        }
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting access role failed', '', error);
        return error;
      })
    );
  }

  getAccessRole(upn): Observable<any> {
    this.appBase = TCCPConstantValues[environment.applicationName];
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting Access Role', '');
    return this.httpService.get(this.appBase.Urls.GET_ACCESS_ROLE_URL + '/' + upn).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting access Role successful', JSON.stringify(data));
        if (!this.storageService.getRoles()) {
          this.storageService.setRoles(_.map(data, 'roles'));
        }
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting access role failed', '', error);
        return error;
      })
    );
  }

  async getAccessRoleAsync(upn): Promise<any> {
    this.appBase = TCCPConstantValues[environment.applicationName];
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting Access Role', '');
    return this.httpService.get(this.appBase.Urls.GET_ACCESS_ROLE_URL + '/' + upn).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting access Role successful', JSON.stringify(data));
        if (!this.storageService.getRoles()) {
          this.storageService.setRoles(_.map(data, 'roles'));
        }
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting access role failed', '', error);
        return error;
      })
    );
  }


  getAccess(feature: string, roles: any): any {
    const userPermission: string = this.storageService.getPermission(roles[0]);
    const userAccess = _.filter(JSON.parse(userPermission), x => {
      if (x.feature === feature) {
        return JSON.stringify(x);
      }
    });
    return userAccess;
  }

  async getAccessAsync(feature: string, roles: any): Promise<any> {
    const response$ = this.getAccessPolicy();
    const response = await lastValueFrom(response$);
    for (let i = 0; i < response.length; i++) {
      const permissionArray: Array<Permission> = [];
      for (let j = 0; j < response[i].modules.length; j++) {
        const permission: Permission = {
          feature: _.get(response[i].modules[j], 'featName'),
          accessLevel: _.get(response[i].modules[j].permissions[0], 'accessLevel'),
          contextUrl: _.get(response[i].modules[j], 'contextUrl'),
          allowedMethod: _.get(response[i].modules[j], 'allowedMethods'),
        };
        permissionArray.push(permission);
      }
      this.storageService.setPermission(_.get(response[i], 'userRole'), JSON.stringify(permissionArray));
    }
    const userPermission: string = this.storageService.getPermission(roles[0]);
    const userAccess = _.filter(JSON.parse(userPermission), x => {
      if (x.feature === feature) {
        return JSON.stringify(x);
      }
    });
    return userAccess;
  }

  getUserInfo(upn: string, division: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting getUserInfo', '');
    return this.httpService.get(this.appBase.Urls.GET_USER_INFO + '/' + upn + '/' + division).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting user info successful', JSON.stringify(data));
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting user info failed', '', error);
        return error;
      })
    );
  }

  updateUserInfo(upn: string, division: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting updateUserInfo', '');
    return this.httpService.put(this.appBase.Urls.UPDATE_USER_INFO + '/' + upn + '/' + division).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting access Role successful', JSON.stringify(data));
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting access role failed', '', error);
        return error;
      })
    );
  }

  getAllErrorMessages(platform?: string) {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting Error Messages', '');
    let url = this.appBase.Urls['GET_ERROR_MESSAGES'];
    if (platform !== undefined) {
      url = platform ? url + '/' + platform : url;
    }
    return this.httpService.get(url).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting Error Messages successful', JSON.stringify(data));
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting Error Messages failed', '', error);
        return error;
      })
    );
  }


  deleteErrorGuide(platform: string, code: string) {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started deleting Error code', '');
    const url = this.appBase.Urls['GET_ERROR_MESSAGES'] + '/' + platform + '/' + code;
    return this.httpService.delete(url).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Deleting Error Messages successful', JSON.stringify(data));
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Deleting Error Messages failed', '', error);
        return error;
      })
    );
  }


  uploadMessageGuideTemplate(excelRequestBody, type: string) {
    const url = this.appBase.Urls['MESSAGE_GUIDE_EXCEL_UPLOAD_PATH'];
    const header = new HttpHeaders();
    header.append('Content-Type', type);
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started deleting Error code', '');
    return this.http.post(url, excelRequestBody, { headers: header }).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Upload Message Guides Template successful', JSON.stringify(data));
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Upload Message Guides Template failed', '', error);
        return error;
      })
    );
  }
  getVehicleInfo(vin): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, this.appBase.methods.getPhoneCompatabilityList,
      'Get Vehicle Info', '');
    const url = environment.baseURL + Utilities.getEnvironment() + 'vehicle-detail/' + vin + '/' + environment.applicationName;
    return this.httpService.get(url).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting vehicle info from cvs', JSON.stringify(data));
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting vehicle info from cvs failed', '', error);
        return error;
      })
    );
  }

  getFilteredFeatures(vehicleFeature: VehicleFeature): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting getFilteredFeatures', '');
    return this.httpService.post(this.appBase.Urls.GET_FILTERED_FEATURE_INFO, vehicleFeature).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'getFilteredFeatures info successful', JSON.stringify(data));
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'getFilteredFeatures failed', '', error);
        return error;
      })
    );
  }

  getImageList(featureType?: string, type?: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting Images', '');
    let url: string = this.appBase.Urls.GET_IMAGE_URL + '?contentType=step';
    if (featureType) {
      url = this.appBase.Urls.GET_IMAGE_URL + '?contentType=' + featureType + '&t=' + new Date().getTime();
    }
    if (type) {
      url = this.appBase.Urls.GET_IMAGE_URL + '?contentType=' + type + '&t=' + new Date().getTime();
    }
    return this.httpService.get(url).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting Images successful', JSON.stringify(data));
        return data;
      })
    );
  }

  getCategoryMapping(source) {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting Error Messages', '');
    const url = this.appBase.Urls.CATEGORY_MAPPING;
    return this.httpService.get(url + '?source=' + source).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting Error Messages successful', JSON.stringify(data));
        return data;
      })
    );
  }

  getSearchSuggestions(searchText) {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getSearchSuggestions,
      'Started getting Error Messages', '');
    const url = this.appBase.Urls.GET_SEARCH_SUGGESTIONS;
    return this.httpService.get(url + '?searchText=' + searchText).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getSearchSuggestions,
          'Getting Error Messages successful', JSON.stringify(data));
        return data;
      })
    );
  }

  getSearchResults(searchText) {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getSearchResults,
      'Started getting Error Messages', '');
    const url = this.appBase.Urls.GET_SEARCH_RESULTS;
    return this.httpService.get(url + '?searchText=' + searchText).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getSearchResults,
          'Getting Error Messages successful', JSON.stringify(data));
        return data;
      })
    );
  }

  getQuickLinks() {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getSearchResults,
      'Started getting Error Messages', '');
    const url = this.appBase.Urls.GET_SEARCH_SUGGESTIONS;
    return this.httpService.get(url).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getSearchResults,
          'Getting Error Messages successful', JSON.stringify(data));
        return data;
      })
    );
  }

  getDisclaimer(id): Observable<any> {
    const url = this.appBase.Urls.GET_DISCLAIMER_URL + '?source=' + environment.applicationName + '&contentId=' + id;
    return this.httpService.get(url).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting flow successful', JSON.stringify(data));
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting flow failed', '', error);
        return error;
      })
    );
  }

  async getModelNameAsync(): Promise<any> {
    return this.httpService.get(`${environment.baseURL}${Utilities.getEnvironment()}vehicle-model?source=${environment.applicationName}`)
      .toPromise().then(
        (data: any) => {
          return data;
        },
        (error: any) => {
          return error;
        });
  }

  setBackground(renderer, appName) {
    const url = window.location.href;
    const headerEl = document.querySelector('.home-header-page');
    renderer.setStyle(headerEl, 'margin-bottom', '5px');
    if (appName === 'toyota') {
      const elContent = document.querySelector('.content-block');
      const el = document.querySelector('.body-wrapper');
      if (url.includes('internal')) {
        renderer.removeClass(el, 'toyota-internal-bg');
        renderer.removeClass(el, 'toyota-external-bg');
      } else {
        renderer.removeClass(el, 'toyota-external-bg');
      }
      const ele = document.querySelector('.toyota-background-image');
      if (url.includes('internal')) {
        renderer.removeClass(el, 'toyota-small-device-internal-bg');
      } else {
        renderer.removeClass(el, 'toyota-small-device-external-bg');
      }
    }

    if (this.appName === 'lexus') {
      const elContent = document.querySelector('.content-block');
      const el = document.querySelector('.body-wrapper');
      if (url.includes('internal')) {
        renderer.removeClass(el, 'lexus-internal-bg');
        renderer.removeClass(el, 'lexus-external-bg');
      } else {
        renderer.removeClass(el, 'lexus-external-bg');
      }
      const ele = document.querySelector('.lexus-background-image');
      if (url.includes('internal')) {
        renderer.removeClass(ele, 'lexus-small-device-internal-bg');
      } else {
        renderer.removeClass(ele, 'lexus-small-device-external-bg');
      }
    }
  }

  getBtPayload(huConfigList, vin) {
    let requestData: HeadUnitPayload;
    if (_.isNil(vin) || _.isEmpty(vin)) {
      requestData = {
        headUnitConfigArray: huConfigList ? huConfigList : [],
        modelName: this.storageService.getBtVehicleModel().name,
        modelCode: this.storageService.getBtModelCode(),
        mpc: this.storageService.getBtMPCCode(),
        mpcOption: false,
        year: this.storageService.getBtVehicleYear().name
      };
    } else {
      requestData = {
        headUnitConfigArray: huConfigList ? huConfigList : [],
        modelName: '',
        modelCode: this.storageService.getBtModelCode(),
        mpc: this.storageService.getBtMPCCode(),
        mpcOption: true,
        year: this.storageService.getBtVehicleYear().name
      };
    }
    return requestData;
  }

  getPayload(huConfigList, vin) {
    let requestData: HeadUnitPayload;
    if (_.isNil(vin) || _.isEmpty(vin)) {
      requestData = {
        headUnitConfigArray: huConfigList,
        modelName: this.storageService.getVehicleModelName(),
        mpc: '',
        mpcOption: false,
        year: this.storageService.getVehicleYear().name
      };
    } else {
      requestData = {
        headUnitConfigArray: huConfigList ? huConfigList : [],
        modelName: '',
        modelCode: this.storageService.getBtModelCode() ?  this.storageService.getBtModelCode() : this.storageService.getModelCode(),
        mpc: this.storageService.getMPCCode(),
        mpcOption: true,
        year: this.storageService.getVehicleYear().name
      };
    }
    return requestData;
  }

  getModel(): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting year', '');
    return this.httpService.get(this.appBase.Urls.MODEL_URL + environment.applicationName).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting vehicle model successful', JSON.stringify(data));
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting vehicle model failed', '', error);
        return error;
      })
    );
  }

  getYear(model: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting year', '');
    return this.httpService.get(this.appBase.Urls.YEAR_URL + '?model=' + encodeURIComponent(model) + '&source=' + environment.applicationName).pipe(
      map((data: any) => {
        this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting vehicle year successful', JSON.stringify(data));
        return data;
      }),
      catchError((error: any) => {
        this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
          'Getting vehicle year failed', '', error);
        return error;
      })
    );
  }

  async getYearDetails(model): Promise<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting Access Role', '');

    try {
      const data: any = await lastValueFrom(this.httpService.get(this.appBase.Urls.YEAR_URL + '?model=' + encodeURIComponent(model) + '&source=' + environment.applicationName));

      this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
        'Getting access Role successful', JSON.stringify(data));

      this.storageService.setRoles(_.map(data, 'roles'));
      return data;
    } catch (error) {
      this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
        'Getting access role failed', '', error);
      throw error; // Rethrow the error for further handling if needed
    }
  }

  async getDataAsPromise(): Promise<any> {
    return await firstValueFrom(this.getmodelName().pipe(tap(response => {
    }))
    )
  }

  async goToVinSearchResultLink(vin, featureType) {
    let resultLink = '';
    const brand: string = _.get(this.vinDetails, 'summary.vehicleSummary.brand');
    environment.applicationName = brand === 'LEX' ? 'lexus' : 'toyota';
    const appURl = window.location.href;
    const env = appURl.includes('//qa') ? 'qa.' : (appURl.includes('//dev') ? 'dev.' : '');
    const modelVehicleYear: number = _.get(this.vinDetails, 'summary.vehicleSummary.modelYear');
    const modelVehicleDesc: string = _.get(this.vinDetails, 'summary.vehicleSummary.modeldescription');
    let modelVehicleName = '';
    this.storageService.setVin(vin);
    let numMatches = 0;
    let modelData;
    modelData = await this.getDataAsPromise();

    for (let i = 0; i < modelData.length; i++) {
      if (modelVehicleDesc && modelVehicleDesc !== undefined) {
        const vinModel = modelVehicleDesc.replace(/-/g, '').replace(/hv/gi, 'Hybrid').toUpperCase().split(" ");
        const modelCompare = modelData[i].model.toUpperCase().split(" ");
        const matches = modelCompare.filter(word => vinModel.includes(word)).length;
        if (matches === modelCompare.length && matches > numMatches) {
          numMatches = matches;
          modelVehicleName = modelData[i].model;
        }

        const appName = brand === 'LEX' ? 'lexus' : 'toyota';
        this.storageService.setVehicleVin(vin, `${appName}/home/${featureType}`);
        this.storageService.setVehicleModelName(encodeURIComponent(modelVehicleName));
        this.storageService.setVehicleModelYear(modelVehicleYear);
        if (appURl.includes('toyotaaudioandconnectedservicessupport')) {
          resultLink = `https://${env}lexusconnectedtechnologysupport.com/lexus/home?model=${modelVehicleName}&year=${modelVehicleYear}&vin=${vin}`;
        } else if (appURl.includes('connectedtechnologiestoyota')) {
          resultLink = `https://${env}connectedtechnologieslexus.com/lexus/home/internal?model=${modelVehicleName}&year=${modelVehicleYear}&vin=${vin}`;
        } else if (appURl.includes('lexusconnectedtechnologysupport')) {
          resultLink = `https://${env}toyotaaudioandconnectedservicessupport.com/toyota/home?model=${modelVehicleName}&year=${modelVehicleYear}&vin=${vin}`;
          } else if (appURl.includes('connectedtechnologieslexus')) {
          resultLink = `https://${env}connectedtechnologiestoyota.com/toyota/home/internal?model=${modelVehicleName}&year=${modelVehicleYear}&vin=${vin}`;
        } else {
          if (brand === 'LEX') {
            if (featureType === 'internal') {
              resultLink = `https://qa.connectedtechnologieslexus.com/lexus/home/internal?model=${modelVehicleName}&year=${modelVehicleYear}&vin=${vin}`;
            } else {
              resultLink = `https://qa.lexusconnectedtechnologysupport.com/lexus/home?model=${modelVehicleName}&year=${modelVehicleYear}&vin=${vin}`;
            }
          } else {
            if (featureType === 'internal') {
              resultLink = `https://qa.connectedtechnologiestoyota.com/toyota/home/internal?model=${modelVehicleName}&year=${modelVehicleYear}&vin=${vin}`;
            } else {
              resultLink = `https://qa.toyotaaudioandconnectedservicessupport.com/toyota/home?model=${modelVehicleName}&year=${modelVehicleYear}&vin=${vin}`;
            }
          }
        }
      }
    };
    return resultLink;
  };

  disableSupportTopicPage(searchForm) {
    const vinKey = 'vin';
    const yearKey = 'year';
    const modelKey = 'model';
    if (searchForm.controls[modelKey].value === '' && searchForm.controls[yearKey].value === '' &&
      searchForm.controls[vinKey].value === '') {
      return true;
    } else {
      if (searchForm.controls[modelKey].value !== '' && searchForm.controls[vinKey].value === ''
        && searchForm.controls[yearKey].value === '') {
        return true;
      }
      if (!(searchForm.controls[vinKey].hasError('required') || (searchForm.controls[vinKey].hasError('minlength')))) {
        return false;
      }
      if (searchForm.controls[modelKey].value !== '' && searchForm.controls[yearKey].value !== '') {
        return false;
      }
      if (searchForm.controls[modelKey].value !== '' &&
        (!(searchForm.controls[vinKey].hasError('required') || (searchForm.controls[vinKey].hasError('minlength'))))) {
        return false;
      } else {
        return true;
      }
    }
  }

  public onModelChange(event, vehicleModel, vehicleYear, searchForm, selectedVehicleModelName, homeURL) {
    let selectedVehicle = selectedVehicleModelName;
    const appURl = window.location.href;
    environment.applicationName = appURl.includes('lexus') ? 'lexus' : 'toyota';
    const vehicleModelName = vehicleModel.find(data => {
      return data.model === searchForm.get('model').value;
    });
    const vehicleModelCode = vehicleModel.find(data => {
      return data.model === searchForm.get('model').value ? data.modelCodes : null;
    });
    selectedVehicle = vehicleModelName ? vehicleModelName.years : null;
    this.storageService.setVehicleYear(null, null);
    if (selectedVehicle) {
      this.storageService.setVehicleModelName(_.get(vehicleModelName, 'model'));
      this.storageService.setModelCode(_.get(vehicleModelCode, 'modelCodes')[0]);
    }
    searchForm.patchValue({
      year: '',
      vin: ''
    });

    const model = searchForm.get('model').value || (event && event.target.value);
    if (model !== '') {
      this.setGTagEventDetails('ModelDropdown', `${model}`, 'Model');
    }
    this.storageService.setVehicleModel(model, homeURL);
    this.selectedModel = ({
      name: model || this.storageService.getVehicleModel(),
      link: '/home'
    }) as BreadcrumbLink;

    const modelFromStorage = this.storageService.getVehicleModel();
    this.loader.show();
    this.breadcrumbService.clearBreadcrumb.emit(true);
    this.breadcrumbService.showBreadcrumb.emit(true);

    this.getYear(this.selectedModel.name || modelFromStorage.name)
      .subscribe(data => {
        if (data) {
          this.loader.hide();
          vehicleYear = data;

          const vYear = this.storageService.getVehicleYear();
          if (vYear && vYear.name) {
            searchForm.patchValue({
              year: vYear.name
            });
          }
          return { year: vehicleYear, selectedModelName: selectedVehicle, form: searchForm };
        }
      }, error => {
        this.loader.hide();
      });
  }

  public onYearChange(event, searchForm, selectedVehicleModelName, homeURL, url) {
    const year = event.target.value;
    const model = searchForm.get('model').value || event.target.value;
    const gen = selectedVehicleModelName.find(data => {
      return `${data.year}` === `${year}`;
    });
    this.storageService.setVehicleGeneration(gen.generation, url);
    if (model !== '' && year !== '') {
      this.setGTagEventDetails('Yeardropdown', `${model}  ${year}`, 'year');
    }
    this.storageService.setVehicleYear(year, homeURL);
    this.storageService.setVehicleModel(searchForm.get('model').value, homeURL);
    const yearFromStorage = this.storageService.getVehicleYear();

    this.selectedYear = ({
      name: year || yearFromStorage.name,
      link: '/home'
    }) as BreadcrumbLink;
  }

  public onBtYearChange(event, searchForm, homeURL) {
    const year = event.target.value;
    const model = searchForm.get('model').value || event.target.value;
    this.storageService.setBtVehicleYear(year, homeURL);
    this.storageService.setBtVehicleModel(searchForm.get('model').value, homeURL);
    this.storageService.setBtVehicleModelName(searchForm.get('model').value);
    const yearFromStorage = this.storageService.getBtVehicleYear();

    this.selectedYear = ({
      name: year || yearFromStorage.name,
      link: '/home'
    }) as BreadcrumbLink;
  }

  public setCVSDetails(cvsResponse, searchForm, featureType, homeURL) {
    const capabilityArray: Array<string> = [];
    if (cvsResponse.summary.vehicleSummary.brand && cvsResponse.summary.vehicleSummary.brand === 'TOY') {
      this.appName = 'toyota';
    }
    else {
      this.appName = 'lexus';
    }
    if (featureType === 'internal') {
      this.storageService.setVehicleVin(_.get(cvsResponse, 'summary.vehicleSummary.vin'), `${this.appName}/home/internal`);
    } else {
      this.storageService.setVehicleVin(_.get(cvsResponse, 'summary.vehicleSummary.vin'), `${this.appName}/home`);
    }
    this.storageService.setMPCCode(_.get(cvsResponse, 'summary.vehicleSummary.mobilePlatformCode'));
    this.storageService.setModelCode(_.get(cvsResponse, 'summary.vehicleSummary.modelCode'));
    const modelYear = _.get(cvsResponse, 'summary.vehicleSummary.modelYear');
    this.storageService.setVehicleModelYear(modelYear);
    this.storageService.setVehicleYear(parseInt(modelYear, 10), homeURL);
    // Prepare the capability array based on the flag
    if (!_.isNil(_.get(cvsResponse, 'vehicleCapabilities.capabilities'))) {
      _.get(cvsResponse, 'vehicleCapabilities.capabilities').forEach(capability => {
        if (_.get(capability, 'value')) {
          const vCapability = _.lowerCase(_.get(capability, 'name'));
          capabilityArray.push(vCapability.replace(/\s+/g, ''));
        }
      });
    }
    /*capability only required to be set in the request */
    const requestData: VehicleFeature = {
      division: this.appName === 'toyota' ? 'Toyota' : 'Lexus',
      type: 'external',
      // type: featureType === 'internal' ? featureType : 'external',
      capabilitiy: capabilityArray
    };
    const feats: Array<string> = [];
    if (!_.isEmpty(capabilityArray)) {
      // Retrieve support topic based on CVS Capability
      this.getFilteredFeatures(requestData).subscribe(features => {
        // Set Array of support Topic in storage
        const feat: Array<string> = features.toString().split(',');
        feat.forEach(feature => {
          feats.push(feature.replace(/\s/g, ''));
        });
        this.storageService.setMappedFeatures(feats);
      });
    }
    /* Navigate to Dashboard Page */
    this.setGTagEventDetails('vin', `${searchForm.controls['vin'].value}`, 'vin');
  }

  checkStepControlType(controlsList) {
    let controlFlag = false;
    for (let i = 0; i < controlsList.length; i++) {
      if (controlFlag) {
        controlsList[i].controlType = 'tile';
        // Changing control type of all the controls to tile for - US 1138
      } else if (controlsList[i].controlName.length > 50) {
        controlFlag = true;
        i = -1;
      } else {
        let nameSplitArray: string[] = [];
        nameSplitArray = controlsList[i].controlName.split(/(\s+)/).filter(x => x.length > 1);
        controlFlag = nameSplitArray.filter(x => x.length > 50).length >= 1 ? true : false;
        i = controlFlag ? -1 : i;
      }
    }
    return controlsList;
  }

  public setAppFeatureType(url) {
    let isInternal = false;
    if (url.includes('internal')) {
      isInternal = true;
      this.storageService.setFeatureType('internal');
    } else {
      if (this.storageService.getFeatureType() === 'internal') {
        isInternal = true;
        this.storageService.setFeatureType('internal');
      } else {
        this.storageService.setFeatureType('');
      }
    }
    return isInternal;
  }

  /* SET Google Analytics for Page details */
  public setGTagPageDetails(title, path, location) {
    this.gtag.pageview({
      page_title: title,
      page_path: path,
      page_location: location
    });
  }

  /* SET Google Analytics for event details */
  public setGTagEventDetails(eventName, category, label) {
    this.gtag.event(eventName, {
      event_category: category,
      event_label: label,
    });
  }

  public getBadgeNames(selectedApp) {

    if (this.badgeList.length === 0) {

      this.badgeList.push({ name: "google", iconLink: `${this.badgeUrl}${selectedApp}/images/badges-google.${this.badgeFileExtension}?${(new Date()).getTime()}` });
      this.badgeList.push({ name: "apple", iconLink: `${this.badgeUrl}${selectedApp}/images/badges-apple.${this.badgeFileExtension}?${(new Date()).getTime()}` });

    }

    return this.badgeList;
  }

  public setBadgeNames(badgeList) {
    this.badgeList = badgeList;
  }


}

